/**
 * @description Fonction pour slider de page intérieur
 * @param root {string}
 * @param type {string}
 * @param slidePerView {object}
 * @constructor
 */

/* eslint-disable no-unused-vars */
/* global bsBreakpoints */

const SliderInt = (
	root,
	type,
	slidePerView = { xl: 3, lg: 2, md: 2, sm: 1 }
) => {
	const $ = {
		root: root,
		slider: `data-slider-${type}`,
		slide: `slide-item`,
		dots: `slide-int-dots`,
		dot: `slide-int-dot`,
		next: 'slide-int-next',
		prev: 'slide-int-prev',
		skip: 'data-skip-slider',
		end: 'data-end-slider',
	};

	let thisSlide = 0;
	let maxSlide;
	let nbSlider;
	let breakpoint;

	let bsBreakpoint = bsBreakpoints.detectBreakpoint();

	if (bsBreakpoint === 'xLarge') {
		breakpoint = 'xl';
	} else if (bsBreakpoint === 'large') {
		breakpoint = 'lg';
	} else if (bsBreakpoint === 'medium') {
		breakpoint = 'md';
	} else {
		breakpoint = 'sm';
	}

	/**
	 * @description A11Y du slider
	 * @param slider {number}
	 * @param thisSlide {number}
	 * @constructor
	 */
	const A11Y = (slider, thisSlide) => {
		const nbSlide = SlidePerView();
		const sliderEnd = thisSlide + nbSlide;

		document
			.querySelectorAll(`[${$.slider}='${slider}'] .${$.slide}`)
			.forEach((item, index) => {
				if (index >= thisSlide && index < sliderEnd) {
					item.setAttribute('data-seen', true);
				} else {
					item.setAttribute('data-seen', false);
				}
			});

		document
			.querySelectorAll(
				`[${$.slider}='${slider}'] .${$.slide}[data-seen='true'] a`
			)
			.forEach((link) => {
				link.tabIndex = 0;
			});

		document
			.querySelectorAll(
				`[${$.slider}='${slider}'] .${$.slide}[data-seen='false'] a`
			)
			.forEach((link) => {
				link.tabIndex = -1;
			});
	};

	/**
	 * @description Fonction pour skip le slider
	 * @param slider {number}
	 */
	const skipSlider = (slider) => {
		document
			.querySelector(`[${$.slider}='${slider}'] [${$.skip}]`)
			.addEventListener('click', () => {
				document
					.querySelector(`[${$.slider}='${slider}'] [${$.end}]`)
					.focus();
			});
	};

	/**
	 * @description Renvoie le numéro de slide actuel su slider
	 * @param slider {number}
	 * @returns {number}
	 * @constructor
	 */
	const ThisSlide = (slider) => {
		const activeDot = document.querySelector(
			`[${$.slider}='${slider}'] .${$.dot}.active`
		);
		let value;
		const hasValue = activeDot || null;

		if (hasValue) {
			value = activeDot.getAttribute('data-nb-slide');
		} else {
			value = 0;
		}

		return Number(value);
	};

	/**
	 * @description Renvoie le nombre de pixel du translate pour le slider
	 * @param slider {number}
	 * @returns {string}
	 */
	const translateSlide = (slider) => {
		const widthSlide = document.querySelector(
			`[${$.slider}='${slider}'] .${$.slide}`
		).scrollWidth;
		const translate = widthSlide * thisSlide;

		return `${translate}`;
	};

	/**
	 * @description Renvoie le nombre de slide par vue celon le breakpoint
	 * @returns {number}
	 * @constructor
	 */
	const SlidePerView = () => {
		return slidePerView[breakpoint];
	};

	/**
	 * @description Return le nombre de slide présent dans le slider
	 * @param slider {number}
	 * @returns {number}
	 * @constructor
	 */
	const MaxSlide = (slider) => {
		return document.querySelectorAll(
			`[${$.slider}='${slider}'] .${$.slide}`
		).length;
	};

	/**
	 * @description Identifie et numérote chaque slider de la page
	 */
	const multiSlider = () => {
		const sliders = document.querySelectorAll(`.${$.root}`);

		nbSlider = sliders.length;

		sliders.forEach((slide, index) => {
			const number = index.toString();
			slide.setAttribute($.slider, number);
		});
	};

	/**
	 * @description Affiche/cache les btn next//prev
	 * @param slider {number}
	 * @param thisSlide {number}
	 */
	const visibilityNextPrev = (slider, thisSlide) => {
		maxSlide = MaxSlide(slider);

		const nbPerView = SlidePerView();
		const btnSkip = document.querySelector(
			`[${$.slider}='${slider}'] [${$.skip}]`
		);
		const btnNext = document.querySelector(
			`[${$.slider}='${slider}'] .${$.next}`
		);
		const btnPrev = document.querySelector(
			`[${$.slider}='${slider}'] .${$.prev}`
		);

		if (maxSlide <= nbPerView) {
			btnSkip.style.visibility = 'hidden';
			btnPrev.tabIndex = -1;
			btnPrev.style.visibility = 'hidden';
			btnPrev.tabIndex = -1;
			btnNext.style.visibility = 'hidden';
			btnNext.tabIndex = -1;
		} else {
			btnSkip.style.visibility = 'inherit';
			btnPrev.tabIndex = 0;

			if (thisSlide === 0) {
				btnNext.style.visibility = 'inherit';
				btnNext.tabIndex = 0;
				btnPrev.style.visibility = 'hidden';
				btnPrev.tabIndex = -1;
			} else if (thisSlide === maxSlide - nbPerView) {
				btnPrev.style.visibility = 'inherit';
				btnPrev.tabIndex = 0;
				btnNext.style.visibility = 'hidden';
				btnNext.tabIndex = -1;
			} else {
				btnPrev.style.visibility = 'inherit';
				btnPrev.tabIndex = 0;
				btnNext.style.visibility = 'inherit';
				btnNext.tabIndex = 0;
			}
		}
	};

	/**
	 * @description Action à effectuer au click sur btn next//prev
	 * @param slider {number}
	 * @param btn {string}
	 * @param clickDot {number}
	 *
	 */
	const nav = (slider, btn = 'next', clickDot = null) => {
		thisSlide = ThisSlide(slider);

		if (clickDot || clickDot === 0) {
			thisSlide = clickDot;
		} else {
			if (btn === 'next') {
				if (thisSlide < maxSlide - 1) {
					thisSlide = thisSlide + 1;
				}
			} else {
				if (thisSlide > 0) {
					thisSlide = thisSlide - 1;
				}
			}
		}

		const translate = translateSlide(slider);

		document
			.querySelectorAll(`[${$.slider}='${slider}'] .${$.slide}`)
			.forEach((item, index) => {
				item.style.transform = `translateX(-${translate}px)`;

				if (index < thisSlide) {
					item.style.opacity = '0';
					item.style.visibility = 'hidden';
				} else {
					item.style.visibility = 'inherit';
					item.style.opacity = '1';
				}
			});

		document
			.querySelectorAll(`[${$.slider}='${slider}'] .${$.dot}`)
			.forEach((dot) => {
				if (dot.classList.contains('active')) {
					dot.classList.remove('active');
				}
				if (
					dot.getAttribute('data-nb-slide') === thisSlide.toString()
				) {
					dot.classList.add('active');
				}
			});
		visibilityNextPrev(slider, thisSlide);
		A11Y(slider, thisSlide);
		if (bsBreakpoint === 'large' || bsBreakpoint === 'xLarge') {
			setTimeout(() => {
				document
					.querySelectorAll(
						`[${$.slider}='${slider}'] .${$.slide}[data-seen='true'] a`
					)[0]
					.focus();
			}, 100);
		}
	};

	/**
	 * @description Action au click sur un dot
	 * @param slider {number}
	 * @constructor
	 */
	const ClickDot = (slider) => {
		document
			.querySelectorAll(`[${$.slider}='${slider}'] .${$.dot}`)
			.forEach((dot) => {
				dot.addEventListener('click', () => {
					const thisDot = Number(dot.getAttribute('data-nb-slide'));

					nav(slider, 'next', thisDot);
					document
						.querySelector(
							`[${$.slider}='${slider}'] .${$.slide}[data-seen='true'] a`
						)
						.focus();
				});
			});
	};

	/**
	 * @description Mise en écoute des btn next//prev
	 */
	const navSlide = (slider) => {
		maxSlide = MaxSlide(slider);
		document
			.querySelector(`[${$.slider}='${slider}'] .${$.next}`)
			.addEventListener('click', () => {
				return nav(slider, 'next');
			});

		document
			.querySelector(`[${$.slider}='${slider}'] .${$.prev}`)
			.addEventListener('click', () => {
				return nav(slider, 'prev');
			});

		ClickDot(slider);
	};

	/**
	 * @description Conception des dotdot
	 * @param slider {number}
	 */
	const dotDot = (slider) => {
		maxSlide = MaxSlide(slider);

		const nbPerView = SlidePerView();
		const nbDot = maxSlide - nbPerView + 1;
		let content = ``;

		document.querySelector(
			`[${$.slider}='${slider}'] .${$.dots}`
		).innerHTML = '';

		if (maxSlide > nbPerView) {
			for (let i = 1; i <= nbDot; i++) {
				content += `<div class="slide-int-dot${
					i === 1 ? ` active` : ''
				}" data-nb-slide="${i - 1}"></div>`;
			}
		}

		document
			.querySelector(`[${$.slider}='${slider}'] .${$.dots}`)
			.insertAdjacentHTML('afterbegin', content);
	};

	/**
	 * @description Génération du slider intérieur
	 */
	const generate = () => {
		multiSlider();

		for (let i = 0; i < nbSlider; i++) {
			dotDot(i);
			visibilityNextPrev(i, thisSlide);
			A11Y(i, thisSlide);
			skipSlider(i);
			navSlide(i);
		}

		window.addEventListener('resize', () => {
			setTimeout(function () {
				bsBreakpoint = bsBreakpoints.getCurrentBreakpoint();
				console.log(bsBreakpoint);
				if (bsBreakpoint === 'xLarge') {
					breakpoint = 'xl';
				} else if (bsBreakpoint === 'large') {
					breakpoint = 'lg';
				} else if (bsBreakpoint === 'medium') {
					breakpoint = 'md';
				} else {
					breakpoint = 'sm';
				}

				thisSlide = 0;

				document.querySelectorAll(`.${$.slide}`).forEach((item) => {
					item.style.transform = `translateX(0)`;
					item.style.visibility = 'inherit';
					item.style.opacity = '1';
				});

				for (let i = 0; i < nbSlider; i++) {
					dotDot(i);
					ClickDot(i);
					visibilityNextPrev(i, thisSlide);
				}
			}, 200);
		});
	};

	generate();
};
